module.exports = __webpack_public_path__ + "static/media/retract.8cd1bd87.svg";